<template>
  <section v-loading="listLoading" class="page-container">
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.id" placeholder="编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="用户编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.content" placeholder="内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.recommend" clearable placeholder="是否推荐" @change="list">
            <el-option label="推荐" value="1"></el-option>
            <el-option label="未推荐" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="请选择状态" @change="list">
            <el-option label="正常" value="0"></el-option>
            <el-option label="删除" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.timeRange"
            type="datetimerange"
            value-format="timestamp"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="Begin time"
            end-placeholder="End time"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.buyersShow"
            clearable
            placeholder="只显示买家秀"
            @change="list"
          >
            <el-option label="显示全部" value="0"></el-option>
            <el-option label="只显示买家秀" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="page-section topics" :style="{ height: tableHeight }">
      <div v-for="(item, topicIndex) in results" :key="item.topicId" class="topic-item">
        <div class="topic-avatar">
          <avatar :user="item.user" :size="40" />
        </div>
        <div class="topic-main">
          <div class="topic-header">
            <a :href="('/user/' + item.user.id) | siteUrl" target="_blank" class="topic-nickname">{{
              item.user.nickname
            }}</a>

            <div class="topic-info">
              <span v-if="item.status === 1" style="color: red; font-weight: bold">已删除</span>
              <span v-if="item.recommend" style="color: red; font-weight: bold">已推荐</span>
            </div>
          </div>

          <div class="topic-metadata">
            <span class="topic-metadata-item">
              <span>ID:</span>
              <span>{{ item.topicId }}</span>
            </span>
            <span class="topic-metadata-item">
              <span>Date：</span>
              <span>{{ item.createTime | formatDate }}</span>
            </span>
            <span class="node">{{ item.node ? item.node.name : "" }}</span>
            <span v-for="tag in item.tags" :key="tag.tagId" class="topic-metadata-item tag"
              >#{{ tag.tagName }}</span
            >
          </div>

          <div class="topic-title">
            <a :href="('/topic/' + item.topicId) | siteUrl" target="_blank">{{ item.title }}</a>
          </div>

          <template v-if="item.type === 0">
            <div class="topic-summary">
              {{ item.summary }}
            </div>
          </template>
          <template v-else>
            <div class="topic-summary">
              {{ item.content }}
            </div>
          </template>

          <ul v-if="item.imageList && item.imageList.length" class="topic-image-list">
            <li v-for="(image, index) in item.imageList" :key="index">
              <a :href="('/topic/' + item.topicId) | siteUrl" target="_blank" class="image-item">
                <img v-lazy="image.preview" />
              </a>
            </li>
          </ul>

          <div class="topic-metas">
            <span>查看: {{ item.viewCount }}</span>
            <span>点赞: {{ item.likeCount }}</span>
            <span>评论: {{ item.commentCount }}</span>
          </div>

          <div class="topic-actions">
            <a class="action-item btn" @click="handleEdit(topicIndex, item)">修改信息</a>
            <a v-if="item.status === 0" class="action-item btn" @click="deleteSubmit(item.topicId)"
              >删除</a
            >
            <el-popconfirm v-else title="是否确认？" @confirm="undeleteSubmit(item.topicId)">
              <a slot="reference" class="action-item btn">取消删除</a>
            </el-popconfirm>

            <a v-if="!item.recommend" class="action-item btn" @click="recommend(item.topicId)"
              >推荐</a
            >
            <a v-else class="action-item btn" @click="cancelRecommend(item.topicId)">取消推荐</a>

            <a class="action-item btn" @click="pushTopic(item.topicId)">推送帖子到APP通知</a>
            <a class="action-item btn" @click="openCommentDialog(item.topicId)">水军</a>

            <mute :user-id="item.user.id">
              <a class="action-item btn">禁言该用户</a>
            </mute>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog :visible.sync="addFormVisible" :close-on-click-modal="false" title="新增">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="80px">
        <el-form-item label="userId" prop="rule">
          <el-input v-model="addForm.userId"></el-input>
        </el-form-item>

        <el-form-item label="title" prop="rule">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>

        <el-form-item label="content" prop="rule">
          <el-input v-model="addForm.content"></el-input>
        </el-form-item>

        <el-form-item label="status" prop="rule">
          <el-input v-model="addForm.status"></el-input>
        </el-form-item>

        <el-form-item label="createTime" prop="rule">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">Cancel</el-button>
        <el-button :loading="addLoading" type="primary" @click.native="addSubmit">Submit</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="commentFormVisable" :close-on-click-modal="false" title="水军">
      <el-form ref="addComment" :model="commentForm" label-width="80px">
        <el-form-item label="水军分类">
          <el-select v-model="commentForm.category" placeholder="请选择水军分类">
            <el-option label="表情库" value="biaoqing"></el-option>
            <el-option label="基础" value="jichu"></el-option>
            <el-option label="球鞋发售" value="qiuxiufashou"></el-option>
            <el-option label="买球鞋" value="buyqiuxie"></el-option>
            <el-option label="卖球鞋" value="saleqiuxie"></el-option>
            <el-option label="开箱" value="kaixiang"></el-option>
            <el-option label="穿搭" value="chuanda"></el-option>
            <el-option label="cop/drop" value="copdrop"></el-option>
            <el-option label="左右选择" value="zuoyou"></el-option>
            <el-option label="美女" value="meinv"></el-option>
            <el-option label="鉴定" value="jianding"></el-option>
            <el-option label="中奖" value="zhongjiang"></el-option>
            <el-option label="球鞋收藏" value="shoucang"></el-option>
            <el-option label="最喜欢的球鞋" value="zuixihuan"></el-option>
            <el-option label="球鞋保养" value="baoyang"></el-option>
            <el-option label="球鞋diy" value="diy"></el-option>
            <el-option label="篮球" value="lanqiu"></el-option>
            <el-option label="晒奖品" value="shaijiang"></el-option>
            <el-option label="W/L" value="wl"></el-option>
            <el-option label="周边" value="zhoubian"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="commentFormVisable = false">Cancel</el-button>
        <el-button :loading="commentLoading" type="primary" @click.native="sendComment"
          >Submit</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="Edit">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="Views">
          <el-input-number v-model="editForm.viewCount" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="Likes">
          <el-input-number v-model="editForm.likeCount" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="Created time">
          <el-date-picker
            v-model="editForm.createTime"
            type="datetime"
            value-format="timestamp"
            placeholder="choose the time"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">Cancel</el-button>
        <el-button :loading="editLoading" type="primary" @click.native="editSubmit"
          >Submit</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import Avatar from "@/components/Avatar";
import Mute from "@/views/pages/user/mute";

export default {
  name: "Topics",
  components: { MyPagination, Avatar, Mute },
  data() {
    return {
      tableHeight: "700px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        status: "0",
      },
      selectedRows: [],
      addForm: {
        forumId: "",
        userId: "",
        title: "",
        content: "",
        status: "",
        createTime: "",
      },
      addFormVisible: false,
      addFormRules: {},
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editFormRules: {},
      editLoading: false,

      commentFormVisable: false,
      commentLoading: false,
      commentForm: {
        category: "",
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    pushTopic(topicId) {
      const me = this;
      this.$prompt("是否推送该帖子，推送后所有app用户都会收到该消息!!!", "请确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputPlaceholder: "推送内容",
        inputValidator: function (value) {
          if (!value) {
            return "请输入推送内容";
          }
        },
      })
        .then(({ value }) => {
          me.axios
            .form("base:/api/admin/push/topic", { topicId, alert: value })
            .then(() => {
              me.$message({
                type: "success",
                message: "推送成功!",
              });
            })
            .catch((e) => {
              me.$message({
                type: "error",
                message: e.message || e,
              });
            });
        })
        .catch(() => {
          me.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });
      this.axios
        .form("base:/api/admin/topic/list", params)
        .then((data) => {
          me.results = data.results;
          me.page = data.page;
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.addForm = {
        name: "",
        description: "",
      };
      this.addFormVisible = true;
    },
    addSubmit() {
      const me = this;
      this.axios
        .form("base:/api/admin/topic/create", this.addForm)
        .then((data) => {
          me.$message({ message: "Submit success", type: "success" });
          me.addFormVisible = false;
          me.list();
        })
        .catch((rsp) => {
          me.$elnotify.error({ title: "error ", message: rsp.message });
        });
    },
    handleEdit(index, row) {
      const me = this;
      this.axios
        .get(`/api/admin/topic/${row.topicId}`)
        .then((data) => {
          me.results[index].viewCount = me.editForm.viewCount;
          me.results[index].likeCount = me.editForm.likeCount;
          me.results[index].createTime = me.editForm.createTime;

          me.editForm = Object.assign({}, data);
          me.editFormVisible = true;
        })
        .catch((rsp) => {
          me.$elnotify.error({ title: "error ", message: rsp.message });
        });
    },
    editSubmit() {
      const me = this;
      this.axios
        .form("base:/api/admin/topic/update", me.editForm)
        .then((data) => {
          me.list();
          me.editFormVisible = false;
        })
        .catch((rsp) => {
          me.$elnotify.error({ title: "error ", message: rsp.message });
        });
    },
    deleteSubmit(topicId) {
      const me = this;
      this.$confirm("是否确认删除该话题?", "提示", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(function () {
          me.axios
            .form("base:/api/admin/topic/delete", { id: topicId })
            .then(function () {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch(function (err) {
              me.$elnotify.error({
                title: "error ",
                message: err.message || err,
              });
            });
        })
        .catch(function () {
          me.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openCommentDialog(topicId) {
      // 初始化数据
      this.commentFormVisable = true;
      this.commentForm.topicId = topicId;
    },
    async sendComment() {
      try {
        if (!this.commentForm.category) {
          this.$message.error("请选择水军分类");
          return;
        }
        if (!this.commentForm.topicId) {
          this.$message.error("请选择要发表水军的帖子");
          return;
        }
        await this.axios.form("base:/api/admin/comment/dummy", {
          topicId: this.commentForm.topicId,
          category: this.commentForm.category,
        });
        this.commentFormVisable = false;
      } catch (e) {
        console.error(e);
        this.$message.error("Comment failed：" + (e.message || e));
      }
    },
    async undeleteSubmit(topicId) {
      try {
        await this.axios.form("base:/api/admin/topic/undelete", { id: topicId });
        this.list();
        this.$message({ message: "Cancel", type: "success" });
      } catch (err) {
        this.$notify.error({ title: "error ", message: err.message || err });
      }
    },
    async recommend(id) {
      try {
        await this.axios.form("base:/api/admin/topic/recommend", {
          id,
        });
        this.$message({ message: "Recommended", type: "success" });
        this.list();
      } catch (e) {
        this.$notify.error({ title: "error ", message: e.message });
      }
    },
    async cancelRecommend(id) {
      try {
        await this.axios.delete("base:/api/admin/topic/recommend", {
          params: {
            id,
          },
        });
        this.$message({ message: "Cancel", type: "success" });
        this.list();
      } catch (e) {
        this.$notify.error({ title: "error ", message: e.message });
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style scoped lang="scss"></style>
